import { soundService } from '../services';
import { SoundTypes } from '../services/baseSoundService/soundService';
import { spinBarStore } from '../store/spinBarStore';

export const checkScattersSounds = (reelIndex, iconNumber) => {
  if ((reelIndex === 0 || !reelIndex % 2) && iconNumber === 11) {
    soundService.play(SoundTypes.starScatterWin);
    soundService.stop(SoundTypes.ReelStop);
  }

  if (iconNumber === 10) {
    if (
      (reelIndex === 3 && spinBarStore.scatterDollarCount < 1) ||
      (reelIndex === 4 && spinBarStore.scatterDollarCount < 2)
    ) {
      soundService.stop(SoundTypes.dollarScatterWin);
    } else {
      soundService.play(SoundTypes.dollarScatterWin);
      soundService.stop(SoundTypes.ReelStop);
    }
  }
};
export const checkJackpotIconSounds = (reelIndex, iconNumber) => {
  if (iconNumber === 400) {
    if (
      (reelIndex === 3 && spinBarStore.jackpotIconCount < 1) ||
      (reelIndex === 4 && spinBarStore.jackpotIconCount < 2)
    ) {
      soundService.stop(SoundTypes.JackpotSymbol);
    } else {
      soundService.stop(SoundTypes.ReelStop);
      soundService.play(SoundTypes.JackpotSymbol);
    }
  }
};
